export const COURRIER_LESSONS = [
  {
    id: 'courrier-1',
    numero: 1,
    titre: "Reconnaître l'expéditeur",
    sousTitre: "À qui a-t-on affaire ?",
    contexte: "Vous recevez une lettre. Avant même de la lire, il faut savoir qui l'envoie — et si c'est sérieux.",
    explication: [
      "**L'en-tête** est en haut de la lettre. C'est là que se trouve le nom de l'organisme : CAF, CPAM, Impôts, Mairie...",
      "**La référence dossier** est un numéro unique qui vous identifie. Notez-le — vous en aurez besoin si vous appelez.",
      "**La date** indique quand la lettre a été envoyée. Attention aux délais qui courent à partir de cette date !",
      "**Un courrier officiel** a toujours un logo, une adresse officielle et une référence. Si ces éléments manquent, méfiance.",
      "**Astuce** : si vous ne reconnaissez pas l'expéditeur, cherchez le nom sur Google avant d'agir.",
    ],
    question: "Sur un courrier CAF, où trouve-t-on le numéro de dossier ?",
    options: [
      { id: 'a', text: "Dans l'en-tête, en haut de la lettre", correct: true },
      { id: 'b', text: "À la fin de la lettre, après la signature", correct: false },
      { id: 'c', text: "Sur l'enveloppe uniquement", correct: false },
    ],
    explication_reponse: "Le numéro de dossier est toujours dans l'en-tête — en haut à droite ou à gauche. C'est la première chose à noter quand vous recevez un courrier officiel.",
  },
  {
    id: 'courrier-2',
    numero: 2,
    titre: "Comprendre l'objet du courrier",
    sousTitre: "Qu'est-ce qu'on me demande ?",
    contexte: "La CAF vous écrit. Mais que veut-elle exactement ? Panique ou pas de panique ?",
    explication: [
      "**La ligne 'Objet'** résume en une phrase la raison du courrier. C'est la première chose à lire.",
      "**3 types de courriers** existent : informatif (on vous informe), demande de pièces (on vous demande quelque chose), décision (on vous accorde ou refuse quelque chose).",
      "**Les mots clés à repérer** : 'nous vous demandons de', 'vous devez fournir', 'votre droit est suspendu', 'sous 15 jours'...",
      "**Ne paniquez pas** à la première lecture. Lisez deux fois calmement avant d'agir.",
      "**Si vous ne comprenez pas**, appelez l'organisme avec votre numéro de dossier. C'est leur rôle de vous expliquer.",
    ],
    question: "Un courrier avec 'Objet : demande de justificatifs' signifie...",
    options: [
      { id: 'a', text: "On me demande d'envoyer des documents", correct: true },
      { id: 'b', text: "Mon dossier est refusé", correct: false },
      { id: 'c', text: "Je dois rappeler dans les 24h", correct: false },
    ],
    explication_reponse: "Une demande de justificatifs n'est pas un refus — c'est une demande d'information. L'organisme a besoin de documents pour traiter votre dossier. Pas de panique, juste une action à faire.",
  },
  {
    id: 'courrier-3',
    numero: 3,
    titre: "Repérer les délais",
    sousTitre: "Combien de temps ai-je ?",
    contexte: "Il y a toujours une date limite dans un courrier officiel. La rater peut vous coûter des droits.",
    explication: [
      "**Les délais courent à partir de la date du courrier** — pas de la date où vous l'avez reçu. Ouvrez vos courriers rapidement !",
      "**Délais fréquents** : 15 jours pour fournir des pièces, 30 jours pour faire un recours, 2 mois pour contester une décision.",
      "**Cherchez les formules** : 'avant le', 'dans un délai de', 'sous peine de', 'au plus tard le'...",
      "**Si vous ne pouvez pas respecter le délai**, contactez l'organisme AVANT l'échéance pour expliquer votre situation. La plupart du temps ils accordent un délai supplémentaire.",
      "**Notez la date limite** sur un calendrier ou dans votre téléphone dès réception du courrier.",
    ],
    question: "Un courrier daté du 1er mars demande une réponse 'sous 15 jours'. Quelle est la date limite ?",
    options: [
      { id: 'a', text: "Le 16 mars", correct: true },
      { id: 'b', text: "Le 15 avril", correct: false },
      { id: 'c', text: "Le 1er avril", correct: false },
    ],
    explication_reponse: "15 jours à partir du 1er mars = 16 mars. Le délai court à partir de la date du courrier. Notez toujours cette date limite dès que vous ouvrez le courrier !",
  },
  {
    id: 'courrier-4',
    numero: 4,
    titre: "Identifier les pièces demandées",
    sousTitre: "Quels documents fournir ?",
    contexte: "Le courrier liste des documents à envoyer. Comment s'y retrouver sans se tromper ?",
    explication: [
      "**La liste des pièces** est souvent en bas du courrier, parfois encadrée ou en gras. Lisez-la attentivement.",
      "**Pièces courantes** : justificatif de domicile (facture EDF, quittance de loyer), pièce d'identité, RIB, bulletin de salaire, avis d'imposition.",
      "**Un justificatif de domicile** doit dater de moins de 3 mois. Vérifiez la date avant d'envoyer.",
      "**Scanner ou photographier** : si vous envoyez en ligne, prenez une photo nette, bien éclairée, document à plat. Toutes les informations doivent être lisibles.",
      "**Conservez une copie** de tout ce que vous envoyez — et notez la date d'envoi.",
    ],
    question: "Un justificatif de domicile acceptable est...",
    options: [
      { id: 'a', text: "Une facture EDF datant de 2 mois", correct: true },
      { id: 'b', text: "Une facture EDF datant de 6 mois", correct: false },
      { id: 'c', text: "Une photo de votre maison", correct: false },
    ],
    explication_reponse: "Un justificatif de domicile doit dater de moins de 3 mois. Une facture de 2 mois est parfaite. Une facture de 6 mois sera refusée. Vérifiez toujours la date avant d'envoyer !",
  },
];
